export default "__VITE_ASSET__47da3fc6__"